/**
 * Created by Administrador on 3/22/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .factory('seatPropertyService',seatPropertyService);

    seatPropertyService.$inject = ['$http', 'CONFIG','messageService'];

    function seatPropertyService($http, CONFIG,messageService){
        var urlBase = CONFIG.API_URL + '/' + CONFIG.API_FLIGHT_CONTROL + '/' + CONFIG.API + '/seatProperties';

        var service = {
            getSeatProperties: getSeatProperties
        }

        return service;

        function getSeatProperties(){
            return $http.get(urlBase)
                .then(function (response) {
                    return response;
                })
                .catch(function () {
                    messageService.findAllError('');
                });
        }
    }
})();
